/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Backdrop,
  Box,
  Breadcrumbs,
  Button,
  Checkbox,
  FormControl,
  IconButton,
  Input,
  InputBase,
  Link,
  MenuItem,
  Modal,
  Select,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';
import '../../../assets/css/task_detail.css';
import React, { FC, useEffect, useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { Icons } from '../../../assets/SvgIcons';
import {
  DependencyType,
  ICTask,
  ICTaskAttachment,
  ICTaskComment,
  ICTaskLog,
  ISUpdateCoreRisk,
  SubscriptionType,
  Tagger,
} from '../../../helper/Interfaces';
import classes from './TaskDetailModal.module.css';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import DependencyCard from '../DependencyCard/DependencyCard';
import CustomDropZone from '../CustomDropZone/CustomDropZone';
import UserMenu from '../UserMenu/UserMenu';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { toast } from 'react-toastify';
import {
  deleteTaskHistory,
  getTaskHistory,
  postTaskHistory,
  selectedTaskDetailUpdate,
} from '../../../store/feature/taskSlice';
import DetailScore from '../DetailScore/DetailScore';
import CustomCkEditor from '../CustomCkEditor/CustomCkEditor';
import { ComponentHelper, useEffectAsync } from '../../../helper/Infra';
import {
  getPlayBookDetail,
  postDealTaskList,
} from '../../../store/feature/playBookDetailSlice';
import moment from 'moment';
import { FunctionalArea } from '../../../pages/authentication/CreateDealspace';
import TaskDetailHistory from './Components/TaskDetailHistory';
import TaskDetailRidCard from './Components/TaskDetailRidCard';
import { useNavigate, useParams } from 'react-router-dom';
import TaskDetailSubTask from './Components/TaskDetailSubTask';
import AddNewDependencyWidget from '../AddNewDependencyWidget/AddNewDependencyWidget';
import { MergefloColors } from '../../../helper/MergefloColors';
import CircularProgress from '@mui/material/CircularProgress';

import { WithContext as ReactTags } from 'react-tag-input';
import {
  getAssetsFunctionalAreas,
  getAssetsPlaybooks,
} from '../../../store/feature/assetsSlice';
import ParentTaskDialog from '../TodoCard/components/ParentTaskDialog';
import CustomDateRange from '../CustomDateRange/CustomDateRange';
import { useQuery } from '../../../helper/utils';
import CopyLinkButton from './Components/CopyLinkButton';
import { getUserInfo } from '@Store/feature/directory';
import { Undo } from '../TodoCard/components/DeleteDialog';
import styled from '@emotion/styled';
import { getPurePlaybookList } from '@Store/feature/purePlaybookSlice';
import { getScrollPosition } from '@Store/feature/listTaskSlice';
import TrialEndBanner, {
  FreeEndBanner,
} from '../TrialEndBanner/TrialEndBanner';
import {
  getPricingType,
  postShowTrialEndModal,
} from '@Store/feature/pricingSlice';
//const API_URL = 'https://77em4-8080.sse.codesandbox.io';
//const UPLOAD_ENDPOINT = 'upload_files';
const componentHelper = new ComponentHelper();

type TaskDetailModalProps = {
  open: boolean;
  onClose: () => void;
  taskDetail: ICTask;
};
const TaskDetailModal: FC<TaskDetailModalProps> = ({
  open,
  onClose,
  taskDetail,
}) => {
  const { id, pid } = useParams();

  const navigate = useNavigate();
  let query = useQuery();

  const dispatch = useAppDispatch();

  const { taskDetailHistory } = useAppSelector(getTaskHistory);
  const [isCommentEditor, setIsCommentEditor] = useState<boolean>(false);
  const [selectedSubTask, setselectedSubTask] = useState<ICTask | undefined>(
    undefined
  );
  const [openParentModal, setopenParentModal] = useState(false);
  const [mouseHoverButton, setMouseHoverButton] = useState(false);
  const currentUser = localStorage.getItem('username');
  const mergefloColors = new MergefloColors();
  const [isUserImo, setisUserImo] = useState(false);
  const pricingReducer = useAppSelector(getPricingType);
  const dealSpaceEnd = componentHelper.isDealspaceTrialEnd(pricingReducer);

  // taskDetail states
  const [taskName, setTaskName] = useState(taskDetail.name ?? '');
  const [taskStartDate, setTaskStartDate] = useState<Date | undefined>(
    undefined
  );
  const [taskDueDate, setTaskDueDate] = useState<Date | undefined>(undefined);
  const [, setBreadCrumbTask] = useState<ICTask[]>([]);
  const [isDescriptionEdit, setIsDescriptionEdit] = useState<boolean>(false);
  const [taskNumber, setTaskNumber] = useState('');
  const [taskType, setTaskType] = useState('');
  const [isCompleted, setIsCompleted] = useState(false);
  const [taskLogs, setTaskLogs] = useState<ICTaskLog[]>([]);
  const [username, setUsername] = React.useState<string>(
    taskDetail?.assignee || ''
  );
  const [description, setDescription] = useState('');
  const [projectRelType, setProjectRelType] = useState('');
  const [shadowTitle, setShadowTitle] = useState('');

  const [riskNumber, setRiskNumber] = useState<string | undefined>(undefined);
  const [decisionNumber, setDecisionNumber] = useState<string | undefined>(
    undefined
  );
  const [issueNumber, setIssueNumber] = useState<string | undefined>(undefined);
  const [dependencyNumber, setDependencyNumber] = useState<string | undefined>(
    undefined
  );
  const [subNumber, setSubNumber] = useState<string | undefined>(undefined);
  const [taskDetailLoading, setTaskDetailLoading] = useState<boolean>(true);

  // end taskDetail states

  //Task Attachment
  const [attachments, setattachments] = useState<ICTaskAttachment[]>([]);

  const [taskComment, setTaskComment] = useState('');
  const [commentList, setCommentList] = useState<ICTaskComment[]>([]);

  //Risk
  const [riskImpact, setRiskImpact] = useState<string>('');
  const [riskLikeliHood, setRiskLikelihood] = useState<string>('');

  //Issue
  const [issueImpact, setIssueImpact] = useState<string>('');
  const [issuePriority, setIssuePriority] = useState<string>('');

  //Decision
  const [decisionMade, setDecisionMade] = useState<string>('');
  const [decisionMaker, setDecisionMaker] = useState<Tagger[]>([]);
  const [decisionPriority, setDecisionPriority] = useState<string>('');

  //Dependency
  const [, setDependencyFuncitonalAreaId] = useState<string>('');
  const [functionAreaCollection, setFunctionAreaCollection] = useState<
    FunctionalArea[]
  >([]);
  //Milestone Button State
  const [isMilestone, setMilestone] = useState<boolean>(false);

  //breadcrumbs
  const [breadCrumbS, setbreadCrumbS] = useState<JSX.Element[]>([]);
  const [hasBrokenPlaybook, setHasBrokenPlaybook] = useState(false);

  const playbooks = useAppSelector(getAssetsPlaybooks);
  const purePlaybooks = useAppSelector(getPurePlaybookList);

  const [taskDetailExpand, setTaskDetailExpand] = React.useState(true);
  const toggleTaskDetailAccordion = () => {
    setTaskDetailExpand(prev => !prev);
  };

  const [filesExpand, setFilesExpand] = React.useState(true);
  const toggleFilesAccordion = () => {
    setFilesExpand(prev => !prev);
  };

  const [commentsExpand, setCommentsExpand] = React.useState(true);
  const toggleCommentsAccordion = () => {
    setCommentsExpand(prev => !prev);
  };

  const { dealTaskList, userList, sectionList } =
    useAppSelector(getPlayBookDetail);
  const functionalAreas = useAppSelector(getAssetsFunctionalAreas);
  const userInfo = useAppSelector(getUserInfo);
  const scrollPosition = useAppSelector(getScrollPosition);
  const [allTasks, setAllTasks] = useState<ICTask[]>([]);

  const [currentTaskList, setCurrentTaskList] = useState<ICTask[]>(
    dealTaskList.filter(i => !i.isArchived)
  );

  const [isTaskInViewMode, setisTaskInViewMode] = useState(false);

  useEffect(() => {
    setCurrentTaskList(
      dealTaskList.filter(i => i.playbookId === pid && !i.isArchived)
    );
    setisTaskInViewMode(!isUserImo && taskDetail.projectRelType === 'viewer');
  }, [sectionList, dealTaskList, id, taskDetail]);

  const getParentTask = (task: ICTask, allParentTask: ICTask[]) => {
    const parent = dealTaskList.find(i => i.id === task.parentId);

    if (parent !== undefined) {
      allParentTask.push(parent);
      getParentTask(parent, allParentTask);
    } else {
      return allParentTask;
    }
  };

  React.useEffect(() => {
    if (playbooks && functionalAreas && id) {
      const worksAssetsPlaybooks = playbooks.filter(f => f.dealspaceId === id);
      setisUserImo(
        worksAssetsPlaybooks.find(w =>
          functionalAreas
            .filter(f => f.isIMO)
            .map(t => t.id)
            .includes(w.functionalAreaId)
        ) !== undefined
      );
    }
  }, [playbooks, functionalAreas, id]);

  function updateDecisionMaker(
    dealTaskList: ICTask[],
    taskDetail: ICTask,
    response: any
  ) {
    let patchAllTasks = [...dealTaskList];
    let headerTask = patchAllTasks.find(i => i.id === taskDetail.id);
    if (headerTask) {
      patchAllTasks = patchAllTasks.filter(i => i.id !== headerTask?.id!);
      const newHeaderTask = JSON.parse(JSON.stringify(headerTask));
      newHeaderTask.decisionMaker = response.decisionMaker
        .replace('{', '')
        .replace('}', '')
        .split(',');
      patchAllTasks.push(newHeaderTask);
    }
    dispatch(postDealTaskList([...patchAllTasks]));
  }

  const saveComments = async (componentInput: string) => {
    const elem = await componentHelper.createComment({
      comment: componentInput,
      taskId: taskDetail.id!,
    });
    const createdComment = {
      comment: componentInput,
      taskId: taskDetail.id!,
      id: elem.data.id,
      username: elem.data.createdBy,
      createdAt: elem.data.createdAt,
    } as ICTaskComment;
    setCommentList(old => [...old, createdComment]);
    setTaskComment('');
  };

  const deleteAttachments = (attachment: ICTaskAttachment) => {
    setattachments(old => [...old.filter(item => item.id !== attachment.id)]);
  };

  const openSelectedTaskHistory = (task: ICTask) => {
    const data = {
      selectedTask: task,
      isShowTaskModal: true,
    };
    dispatch(selectedTaskDetailUpdate(data));
  };

  const createSubBreadcrumb = (
    bcCollection: JSX.Element[],
    incomingTask: ICTask,
    key: number
  ) => {
    let current = [...bcCollection] as any;

    if (incomingTask.id !== taskDetail.id) {
      current.push(
        <Link
          underline="hover"
          key={key.toString()}
          style={{ fontStyle: incomingTask.name === ' ' ? 'italic' : 'normal' }}
          color="inherit"
          onClick={() => {
            openSelectedTaskHistory(incomingTask);
          }}
        >
          {(incomingTask.name?.length ?? 0) > 30
            ? incomingTask.name?.substring(0, 30) + '...'
            : incomingTask.name === ' '
            ? 'Unnamed Dependency'
            : incomingTask.name}
        </Link>
      );
    }
    if (incomingTask.parentId) {
      const parentable = dealTaskList.find(f => f.id === incomingTask.parentId);
      if (parentable) {
        current = createSubBreadcrumb(current, parentable, key - 1);
      }
    } else {
      if (taskType !== 'dependency') {
        current.push(
          <Link
            underline="hover"
            key="2"
            color="inherit"
            onClick={() => {
              onModalClose(false);
              const isListTab = window.location.href.indexOf('playbook') > -1;
              if (!isListTab) {
                navigate(
                  '../playbook/' +
                    (id ?? taskDetail.dealspaceId) +
                    '/' +
                    taskDetail.playbookId +
                    '/2',
                  {
                    state: {
                      rollSectionId:
                        sectionList?.find(i => i.id === incomingTask.sectionId)
                          ?.id ?? '',
                    },
                  }
                );
              }
              const violation = document.getElementById(
                sectionList?.find(i => i.id === incomingTask.sectionId)?.id ??
                  ''
              );
              if (violation) {
                window.scrollTo({
                  top: violation.offsetTop,
                  behavior: 'smooth',
                });
              }
            }}
          >
            {incomingTask.sectionName ??
              sectionList?.find(s => s.id === incomingTask.sectionId)?.name}
          </Link>
        );
      }
    }
    return [...current];
  };

  const handleCheckboxChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (dealSpaceEnd) {
      dispatch(postShowTrialEndModal(true));
      return;
    }
    const checkStatus = event.target.checked;
    setMilestone(!isMilestone);
    if (checkStatus) {
      componentHelper.convertToMilestone(taskDetail.id!).then(() => {
        toast('Converted to milestone');
        setTaskType('milestone');
      });
    } else {
      componentHelper.milestoneToTask(taskDetail.id!).then(() => {
        toast('Converted to normal task');
        setTaskType('task');
      });
    }
    const newTaskList = JSON.parse(JSON.stringify(allTasks)) as ICTask[];
    const index = dealTaskList.findIndex(emp => emp.id === taskDetail.id);
    const newVersion = { ...newTaskList[index] };
    (newVersion as any)['type'] = checkStatus ? 'milestone' : 'task';
    newTaskList[index] = newVersion;

    const taskLogList = (await componentHelper.listTaskLogs(
      taskDetail.id!
    )) as ICTaskLog[];
    setTaskLogs(taskLogList);

    dispatch(postDealTaskList(newTaskList));
  };

  useEffectAsync(async () => {
    const detailResponse = (await componentHelper.getTaskDetail(
      taskDetail.id!
    )) as ICTask;

    setProjectRelType(taskDetail.projectRelType ?? '');
    setTaskName(detailResponse.task?.name ?? '');
    setTaskDueDate(
      detailResponse.task?.dueDate
        ? moment(detailResponse.task?.dueDate.split('T')[0]).toDate()
        : undefined
    );

    setTaskStartDate(
      detailResponse.task?.startDate
        ? moment(detailResponse.task?.startDate.split('T')[0]).toDate()
        : undefined
    );
    setTaskNumber(
      detailResponse.task?.itemNumber ?? taskDetail.itemNumber ?? ''
    );

    setUsername(taskDetail?.assignee ?? '');
    setIsCompleted(detailResponse.task?.isCompleted ?? false);
    setTaskType(detailResponse.task?.type ?? '');
    setDescription(detailResponse.task?.description ?? '');
    if (detailResponse.task?.risk) {
      setRiskImpact(detailResponse.task.risk.impact);
      setRiskLikelihood(detailResponse.task.risk.likelihood);
    }
    if (detailResponse.task?.issue) {
      setIssueImpact(detailResponse.task.issue.impact);
      setIssuePriority(detailResponse.task.priority ?? '');
    }
    if (detailResponse.task?.decision) {
      setDecisionMade(detailResponse.task.decision.decisionMade);
      const tagDecision = detailResponse.task.decision.decisionMaker;
      const tagArray = [];
      if (tagDecision && tagDecision.length > 0) {
        for (const item of tagDecision) {
          tagArray.push({ id: item, text: item } as Tagger);
        }
        setDecisionMaker(tagArray);
      }
      setDecisionPriority(detailResponse.task.priority ?? '');
    }

    if (detailResponse.dependency) {
      setFunctionAreaCollection(functionalAreas ?? []);
      if (detailResponse.dependency.functionalAreaId)
        setDependencyFuncitonalAreaId(
          detailResponse.dependency.functionalAreaId
        );
    }

    if (taskDetail.type === 'dependency') {
      setHasBrokenPlaybook(
        (purePlaybooks?.find(
          p => p.functionalAreaId === taskDetail.dependencySource
        )?.project.isDeleted ??
          false) ||
          (purePlaybooks?.find(
            p => p.functionalAreaId === taskDetail.dependencyTarget
          )?.project.isDeleted ??
            false)
      );
    }

    const listComment = (await componentHelper.listTaskComments(
      taskDetail.id!
    )) as ICTaskComment[];
    const taskLogList = (await componentHelper.listTaskLogs(
      taskDetail.id!
    )) as ICTaskLog[];
    setTaskLogs(taskLogList);

    setCommentList(listComment);
  }, [taskDetail]);

  useEffectAsync(async () => {
    const taskAttachments = await componentHelper.getTaskAttachments(
      taskDetail.id ?? ''
    );
    if (taskAttachments.error) {
    }
    setattachments(taskAttachments);
  }, [taskDetail]);

  useEffect(() => {
    setShadowTitle(
      taskDetail.projectRelType === 'target' && taskName === ' '
        ? 'Enter your task name'
        : ''
    );
  }, [taskDetail, taskName]);

  useEffect(() => {
    let breadCrumbElements = [] as JSX.Element[];
    let taskCrumbElements = [] as JSX.Element[];
    if (taskDetail.type !== 'dependency') {
      breadCrumbElements.push(
        <Link
          underline="hover"
          key="1"
          color="inherit"
          onClick={() => onModalClose(false)}
        >
          {taskType === 'dependency'
            ? functionalAreas?.find(
                i => i.id === (taskDetail.dependencySource ?? '')
              )?.shortName
            : playbooks?.find(i => i.id === taskDetail.playbookId ?? '')
                ?.name}{' '}
        </Link>
      );
      const key = 1000;
      taskCrumbElements = createSubBreadcrumb(
        taskCrumbElements,
        taskDetail,
        key
      );

      setbreadCrumbS([...breadCrumbElements, ...taskCrumbElements]);
    } else {
      breadCrumbElements.push(
        <Link
          underline="hover"
          key="-1"
          color="inherit"
          onClick={() => onModalClose(false)}
        >
          <span
            style={{
              textDecoration: purePlaybooks?.find(
                i => i.functionalAreaId === (taskDetail.dependencyTarget ?? '')
              )?.project.isDeleted
                ? 'line-through'
                : 'auto',
            }}
          >
            {
              purePlaybooks?.find(
                p => p.functionalAreaId === (taskDetail.dependencyTarget ?? '')
              )?.project.name
            }
          </span>
        </Link>
      );

      breadCrumbElements.push(
        <Link
          underline="hover"
          key="1"
          color="inherit"
          onClick={() => onModalClose(false)}
        >
          {taskDetail.parentTaskName ?? ''}
        </Link>
      );
      setbreadCrumbS([...breadCrumbElements]);
    }
  }, [taskDetail, taskType]);

  useEffect(() => {
    setAllTasks(dealTaskList);

    const breadTask = [] as ICTask[];
    const detailOnList = dealTaskList.find(i => i.id === taskDetail.id!);

    if (detailOnList) {
      breadTask.push(detailOnList);

      getParentTask(detailOnList, breadTask);
      setBreadCrumbTask([...breadTask.reverse()]);
    }
    const updatedTask = dealTaskList.find(i => i.id === taskDetail.id);

    setIssueNumber(updatedTask?.issueCount?.toString());
    setRiskNumber(updatedTask?.riskCount?.toString());
    setDependencyNumber(updatedTask?.dependenciesCount?.toString());
    setDecisionNumber(updatedTask?.decisionCount?.toString());
    setSubNumber(updatedTask?.subTaskCount?.toString());
  }, [dealTaskList, taskDetail]);

  function getCompleteButtonName(key: string): string {
    switch (key) {
      case 'risk':
        return isCompleted
          ? mouseHoverButton
            ? 'Reopen Risk'
            : 'Closed Risk'
          : 'Close Risk';
      case 'issue':
        return isCompleted
          ? mouseHoverButton
            ? 'Reopen Issue '
            : 'Closed Issue'
          : 'Close Issue';
      case 'decision':
        return isCompleted
          ? mouseHoverButton
            ? 'Reopen Decision '
            : 'Closed Decision'
          : 'Close Decision';
      case 'dependency':
        return isCompleted
          ? mouseHoverButton
            ? 'Reopen Dependency '
            : 'Closed Dependency'
          : 'Close Dependency';
      default:
        return isCompleted
          ? mouseHoverButton
            ? 'Mark As Incomplete'
            : 'Task Done'
          : ' Mark As Completed';
    }
  }
  const getModalIcon = (key: DependencyType): any => {
    switch (key) {
      case DependencyType.risk:
        return <Icons.RiskHeader width={41} height={41} color="#7D7A9A" />;
      case DependencyType.issue:
        return <Icons.Issues20 width={41} height={41} color="#7D7A9A" />;
      case DependencyType.decision:
        return <Icons.Decision20 width={44} height={41} color="#7D7A9A" />;
      case DependencyType.dependency:
        return <Icons.DependencyHeader color="#7D7A9A" />;
      case DependencyType.subtask:
        return <Icons.SubTaskIcon width={41} height={41} color="#615E84" />;
      default:
        break;
    }
  };

  const getDescription = (key: DependencyType) => {
    switch (key) {
      case DependencyType.risk:
        return 'Plan out your details for risk mitigation';
      case DependencyType.issue:
        return 'Plan out your details for issue mitigation';
      case DependencyType.decision:
        return 'Add more details about the decision';
      case DependencyType.subtask:
        return 'Add more details about the task';
      case DependencyType.milestone:
        return 'Add more details about the milestone';
      case DependencyType.dependency:
        return 'Add more details about the dependency';
      default:
        return 'Add more details about the task';
    }
  };

  const deleteTask = async (currentTask: ICTask, stopDelete?: string) => {
    if (taskType === 'dependency') {
      const depTask = allTasks.find(i => i.id === taskDetail.id!);
      if (depTask) {
        if (
          depTask.projectRelType === 'target' &&
          !depTask.sourceDeleted &&
          !hasBrokenPlaybook
        ) {
          toast(`You can't delete incoming dependency task`);
          return false;
        }
      }
    }
    if (stopDelete === 'init') {
      dispatch(
        postDealTaskList(
          dealTaskList.filter(task => task.id !== currentTask.id)
        )
      );
      let patchAllTasks = [...dealTaskList] as ICTask[];
      dispatch(
        postDealTaskList([...patchAllTasks.filter(i => i.id !== taskDetail.id)])
      );
      if (taskDetail.type !== 'task') {
        let headerTask = patchAllTasks.find(i => i.id === taskDetail.parentId);
        if (headerTask) {
          patchAllTasks = patchAllTasks.filter(i => i.id !== headerTask?.id!);
          const newHeaderTask = JSON.parse(
            JSON.stringify(headerTask)
          ) as ICTask;
          if (taskType === 'risk') {
            newHeaderTask.riskCount = newHeaderTask.riskCount
              ? newHeaderTask.riskCount - 1
              : newHeaderTask.riskCount;
          } else if (taskType === 'issue') {
            newHeaderTask.issueCount = newHeaderTask.issueCount
              ? newHeaderTask.issueCount - 1
              : newHeaderTask.issueCount;
          } else if (taskType === 'decision') {
            newHeaderTask.decisionCount = newHeaderTask.decisionCount
              ? newHeaderTask.decisionCount - 1
              : newHeaderTask.decisionCount;
          } else if (taskType === 'subtask') {
            newHeaderTask.subTaskCount = newHeaderTask.subTaskCount
              ? newHeaderTask.subTaskCount - 1
              : newHeaderTask.subTaskCount;
          }

          patchAllTasks.push(newHeaderTask);
        }

        dispatch(
          postDealTaskList(patchAllTasks.filter(t => t.id !== taskDetail.id))
        );
        const taskNumber = dealTaskList.find(
          task => task.id === taskDetail.parentId
        );
        if (taskNumber) {
          navigate({
            pathname: window.location.pathname,
            search: `?selectedIssue=${taskNumber.itemNumber}`,
          });
        } else {
          onModalClose(false);
        }
      } else {
        onModalClose(false);
      }

      const res = await componentHelper.deleteTask(currentTask.id!);
      localStorage.setItem(currentTask.id + 'delete', JSON.stringify(res));
    } else if (stopDelete === 'normal') {
    } else if (stopDelete === 'break') {
      await componentHelper.deleteUndoTask(
        currentTask.id!,
        JSON.parse(localStorage.getItem(currentTask.id + 'delete') ?? '')
      );
      dispatch(postDealTaskList([...dealTaskList]));
    }

    onModalClose(false);
    return true;
  };

  const archiveTask = async () => {
    await updateTaskDetailService('isArchived', true);
    let patchAllTasks = [...dealTaskList];
    let headerTask = patchAllTasks.find(i => i.id === taskDetail.id);
    if (headerTask) {
      patchAllTasks = patchAllTasks.filter(i => i.id !== headerTask?.id!);
      const newHeaderTask = JSON.parse(JSON.stringify(headerTask));
      newHeaderTask.isArchived = true;
      patchAllTasks.push(newHeaderTask);
    }
    dispatch(postDealTaskList([...patchAllTasks]));
    toast(taskDetail.itemNumber + ' has successfully been archived');
    onModalClose(false);
  };

  const updateTaskDetailService = async (
    columnId: string,
    newValue: any,
    isNumber?: boolean
  ) => {
    if (taskDetail) {
      const newTaskDetail = {
        id: taskDetail.id,
      } as unknown as ICTask;

      if (isNumber) {
        (newTaskDetail as any)[columnId] = parseFloat(newValue as string);
      } else {
        (newTaskDetail as any)[columnId] = newValue;
      }

      const data = (await componentHelper.updateTask(
        newTaskDetail
      )) as ICTask[];

      if (data.length > 0) {
        let newTaskList = JSON.parse(JSON.stringify(allTasks)) as ICTask[];
        const effectedTasks = newTaskList.filter(i => i.id === taskDetail.id);
        for (const item of effectedTasks) {
          newTaskList = newTaskList.filter(f => f !== item);
          let newItem = JSON.parse(JSON.stringify(item));
          (newItem as any)[columnId] = newValue;
          newTaskList.push(newItem);
        }

        dispatch(postDealTaskList(newTaskList));
      }
      const taskLogList = (await componentHelper.listTaskLogs(
        taskDetail.id!
      )) as ICTaskLog[];
      setTaskLogs(taskLogList);
    }
  };

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme, title }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: title === 'Copied!' ? '#00875A' : '#0E0942',
      color: ' #F4F4F7;',
      width: 'fit-content',
      fontSize: 14,
      height: 25,
      borderRadius: 29,
      textAlign: 'center',
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }));

  //function uploadAdapter(loader: any) {
  //  return {
  //    upload: () => {
  //      return new Promise((resolve, reject) => {
  //        const body = new FormData();
  //        loader.file.then((file: File) => {
  //          body.append('files', file);
  //          // let headers = new Headers();
  //          // headers.append("Origin", "http://localhost:3000");
  //          fetch(`${API_URL}/${UPLOAD_ENDPOINT}`, {
  //            method: 'post',
  //            body: body,
  //            // mode: "no-cors"
  //          })
  //            .then(res => res.json())
  //            .then(res => {
  //              resolve({
  //                default: `${API_URL}/${res.filename}`,
  //              });
  //            })
  //            .catch(err => {
  //              reject(err);
  //            });
  //        });
  //      });
  //    },
  //  };
  //}

  //function uploadPlugin(editor: any) {
  //  editor.plugins.get('FileRepository').createUploadAdapter = (
  //    loader: any
  //  ) => {
  //    return uploadAdapter(loader);
  //  };
  //}

  const updateRisk = async (property: string, newValue: any) => {
    if (taskType === 'risk') {
      const newTaskRisk = {} as unknown as ISUpdateCoreRisk;
      (newTaskRisk as any)[property] = newValue;

      await componentHelper.updateRisk(taskDetail.id!, newTaskRisk);

      const taskLogList = await componentHelper.listTaskLogs(taskDetail.id!);
      setTaskLogs(taskLogList);
    }
  };

  const updateIssue = async (property: string, newValue: any) => {
    if (taskType === 'issue') {
      const newTaskIssue = {} as unknown;
      (newTaskIssue as any)[property] = newValue;

      await componentHelper.updateIssue(taskDetail.id!, newTaskIssue as any);
      const taskLogList = await componentHelper.listTaskLogs(taskDetail.id!);
      setTaskLogs(taskLogList);
    }
  };

  const updateDecision = async (property: string, newValue: any) => {
    if (taskType === 'decision') {
      const newTaskIssue = {} as unknown;
      (newTaskIssue as any)[property] = newValue;

      await componentHelper.updateDecision(taskDetail.id!, newTaskIssue as any);

      const taskLogList = await componentHelper.listTaskLogs(taskDetail.id!);
      setTaskLogs(taskLogList);
    }
  };

  const windowMinimize = () => {
    if (!taskDetailHistory.find(task => task.id === taskDetail.id)) {
      dispatch(postTaskHistory(taskDetail));
    }
    onModalClose(true);
  };

  const updateSubTask = (taskList: ICTask[]) => {
    if (taskList?.length > 0) {
      const newTaskList = JSON.parse(JSON.stringify(allTasks)) as ICTask[];
      taskList.map(task => {
        const index = dealTaskList.findIndex(emp => emp.id === task.id);
        const newVersion = { ...newTaskList[index] };
        (newVersion as any)['orderNumber'] = task.orderNumber;
        newTaskList[index] = newVersion;
      });

      dispatch(postDealTaskList(newTaskList));
    }
  };

  const updateTask = async (currentTask: ICTask, username: string) => {
    const data = (await componentHelper.updateTask({
      id: currentTask.id,
      assignee: username.length > 0 ? username : null,
    })) as ICTask[];
    if (data.length > 0) {
      const newTaskList = JSON.parse(
        JSON.stringify(currentTaskList)
      ) as ICTask[];
      //const newTaskList = [...currentTaskList];
      const index = newTaskList.findIndex(emp => emp.id === data[0].id);
      const newVersion = newTaskList[index];
      newVersion.assignee = username.length > 0 ? username : null;
      newTaskList[index] = newVersion;

      dispatch(postDealTaskList(newTaskList));
    }
    const taskLogList = (await componentHelper.listTaskLogs(
      taskDetail.id!
    )) as ICTaskLog[];
    setTaskLogs(taskLogList);
  };

  useEffect(() => {
    if (open) {
      navigate({
        pathname: window.location.pathname,
        search: `?selectedIssue=${taskDetail.itemNumber}`,
      });
    }
  }, [open, navigate, taskDetail]);

  const onModalClose = (windowMinimize: boolean) => {
    if (!windowMinimize) {
      dispatch(deleteTaskHistory(taskDetail.id!));
    }
    navigate({
      pathname: window.location.pathname,
      search: ``,
    });
    onClose();
  };

  useEffect(() => {
    setTaskDetailLoading(true);
    setTimeout(() => {
      setTaskDetailLoading(false);
    }, 600);
  }, [query.get('selectedIssue')]);

  const TaskDetailHistoryChange = (isBack: boolean) => {
    setTaskDetailLoading(true);
    let task = null;
    const index = taskDetailHistory.findIndex(
      item => item.itemNumber === taskDetail.itemNumber
    );
    if (isBack) {
      task = taskDetailHistory[index - 1];
    } else {
      task = taskDetailHistory[index + 1];
    }

    if (task) {
      const data = {
        selectedTask: task,
        isShowTaskModal: true,
      };
      dispatch(selectedTaskDetailUpdate(data));
      // navigate({
      //   pathname: window.location.pathname,
      //   search: `?selectedIssue=${task.taskNumber}`,
      // });
    } else {
      setTaskDetailLoading(false);
    }
  };

  const disableTaskDetailHistoryChangeButton = (isBack: boolean) => {
    if (open) {
      const index = taskDetailHistory.findIndex(
        item => item.itemNumber === taskDetail.itemNumber
      );
      if (isBack) {
        return taskDetailHistory[index - 1]?.id ? false : true;
      } else {
        return taskDetailHistory[index + 1]?.id ? false : true;
      }
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      disableEnforceFocus
      onClose={async () => {
        onModalClose(false);
      }}
      //closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <div className={classes.taskDetailModal}>
        {taskDetailHistory?.length > 0 && (
          <button
            className={classes.modalButtonLeft}
            onClick={() => TaskDetailHistoryChange(true)}
            disabled={disableTaskDetailHistoryChangeButton(true)}
          >
            <ArrowBackIosNewIcon
              sx={{
                fontSize: 35,
                color: '#fff',
              }}
            />
          </button>
        )}

        <div className={classes.modalContainer}>
          {taskDetailLoading ? (
            <div
              style={{
                display: 'flex',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <>
              <div className={classes.taskDetailModalHeader}>
                <div className={classes.taskDetailModalHeaderHistory}>
                  {taskType === 'dependency' && (
                    <div className={classes.taskDateInfoItemText}>
                      {taskDetail.name}
                    </div>
                  )}
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                    maxItems={3}
                    style={{ maxWidth: '20rem' }}
                  >
                    {taskDetail.sourceDeleted && <Icons.SourceDeleted />}
                    {breadCrumbS
                      .sort((a, b) =>
                        (a as any).key < (b as any).key ? -1 : 1
                      )
                      .map(i => {
                        return i;
                      })}
                  </Breadcrumbs>
                </div>
                <div className={classes.taskDetailModalHeaderOperation}>
                  {taskType !== 'dependency' && (
                    <DetailScore
                      subTask={Number(subNumber ?? 0)}
                      risks={Number(riskNumber ?? 0)}
                      decision={Number(decisionNumber ?? 0)}
                      dependency={Number(dependencyNumber ?? 0)}
                      issues={Number(issueNumber ?? 0)}
                    />
                  )}

                  <div className={classes.verticalLine}></div>
                  <TaskDetailHistory
                    taskLogs={taskLogs}
                    taskId={taskDetail.id ?? ''}
                  />
                  {!['risk', 'issue', 'decision', 'dependency'].includes(
                    taskType
                  ) && (
                    <HtmlTooltip title={'Archive'} placement="top">
                      <IconButton
                        size="small"
                        onClick={() => {
                          if (dealSpaceEnd) {
                            dispatch(postShowTrialEndModal(true));
                            return;
                          }
                          archiveTask();
                        }}
                        disabled={
                          taskDetail.isArchived || isTaskInViewMode
                            ? true
                            : false
                        }
                        className={classes.headerIcon}
                      >
                        <Icons.Archive />
                      </IconButton>
                    </HtmlTooltip>
                  )}

                  <CopyLinkButton taskNumber={taskDetail.itemNumber || ''} />
                  <HtmlTooltip title={'Delete'} placement="top">
                    <IconButton
                      size="small"
                      className={classes.Delete2Button}
                      onClick={async () => {
                        if (dealSpaceEnd) {
                          dispatch(postShowTrialEndModal(true));
                          return;
                        }
                        const deletionResponse = await deleteTask(
                          taskDetail,
                          'init'
                        );
                        if (deletionResponse === false) {
                          return;
                        }
                        dispatch(deleteTaskHistory(taskDetail.id ?? ''));
                        toast(
                          <Undo
                            onUndo={() => {
                              deleteTask(taskDetail, 'break');
                            }}
                            message="Successfully deleted"
                            taskName={taskDetail.name ?? ''}
                          />,
                          {
                            onClose: () => {
                              console.log('normal');
                            },
                          }
                        );
                      }}
                      disabled={
                        taskDetail.isArchived || isTaskInViewMode ? true : false
                      }
                    >
                      <Icons.Delete2 color="#6E6B8C" />
                    </IconButton>
                  </HtmlTooltip>
                  <HtmlTooltip title={'Collapse'} placement="top">
                    <IconButton
                      size="small"
                      onClick={windowMinimize}
                      className={classes.headerIcon}
                    >
                      <Icons.WindowMinimize />
                    </IconButton>
                  </HtmlTooltip>
                  <HtmlTooltip title={'Close'} placement="top">
                    <IconButton
                      size="small"
                      className={classes.CancelButton}
                      onClick={() => onModalClose(false)}
                    >
                      <Icons.Cancel />
                    </IconButton>
                  </HtmlTooltip>
                </div>
              </div>
              <div className={classes.taskDetailModalTitle}>
                {taskType !== 'task' && taskType !== 'milestone' && (
                  <div className="editTaskID" style={{ width: '2.72em' }}>
                    <InputBase
                      style={{ width: '100px', height: 44 }}
                      startAdornment={getModalIcon(taskType as DependencyType)}
                      readOnly
                    />
                  </div>
                )}

                <div className="editTaskID">
                  <InputBase
                    style={{ width: '100px', height: 44 }}
                    value={(taskDetail as any).itemNumber ?? taskNumber}
                    readOnly
                  />
                </div>
                <div className="editTaskName">
                  <InputBase
                    style={{ width: '100%', height: 44 }}
                    value={shadowTitle !== '' ? shadowTitle : taskName}
                    disabled={
                      (taskDetail.projectRelType === 'source' && !isUserImo) ||
                      taskDetail.isArchived ||
                      isTaskInViewMode
                        ? true
                        : false
                    }
                    onChange={evt => {
                      if (dealSpaceEnd) {
                        dispatch(postShowTrialEndModal(true));
                        return;
                      }
                      setTaskName(evt.target.value);
                    }}
                    onBlur={evt => {
                      if (taskDetail.name !== taskName) {
                        updateTaskDetailService('name', taskName);
                      }
                    }}
                    onFocus={evt => {
                      setShadowTitle('');
                    }}
                  />
                </div>
                <Button
                  className={[
                    'FuchsiaBlueButton',
                    taskType === 'dependency' && projectRelType === 'decision'
                      ? 'FuchsiaBlueButtondisabled'
                      : '',
                  ].join(' ')}
                  disabled={
                    (projectRelType === 'source' && !isUserImo) ||
                    taskDetail.isArchived ||
                    isTaskInViewMode
                      ? true
                      : false
                  }
                  onClick={() => {
                    if (dealSpaceEnd) {
                      dispatch(postShowTrialEndModal(true));
                      return;
                    }
                    if (
                      taskType === 'decision' &&
                      (decisionMade === null || decisionMade === '') &&
                      !isCompleted
                    ) {
                      toast(
                        'Decision tasks cannot be completed until Decision Made is fulfilled!'
                      );
                      return;
                    }

                    updateTaskDetailService('isCompleted', !isCompleted);
                    setIsCompleted(!isCompleted);
                    const newTask = { ...taskDetail };
                    if (newTask.task) {
                      newTask.task.isCompleted = !isCompleted;
                    }
                    //setTaskDetail(newTask);
                    toast(
                      'Successfully set as ' +
                        (!isCompleted ? 'completed' : 'incompleted')
                    );
                  }}
                >
                  {isCompleted ? <></> : <Icons.Check />}

                  <span
                    style={{ marginLeft: isCompleted ? 0 : 10 }}
                    onMouseOver={() => setMouseHoverButton(true)}
                    onMouseLeave={() => setMouseHoverButton(false)}
                  >
                    {
                      <span style={{ fontSize: '12px' }}>
                        {getCompleteButtonName(taskType).toUpperCase()}
                      </span>
                    }
                  </span>
                </Button>
              </div>
              {dealSpaceEnd && <TrialEndBanner />}
              {purePlaybooks?.find(i => i.id === (pid ?? ''))?.project.isFree &&
                [
                  SubscriptionType.DEALPLAYBOOK,
                  SubscriptionType.FREE,
                  SubscriptionType.USERBASEPAID,
                ].includes(pricingReducer.pricingType) && <FreeEndBanner />}
              <div className={classes.taskDetailModalBody}>
                <div className={classes.taskDetailModalBodyLeft}>
                  {/* {taskType === 'dependency' && (
                    <DependencyInfoBox task={taskDetail} dependency={functionalAreas}/>
                  )} */}
                  {taskType === 'dependency' &&
                    (hasBrokenPlaybook || taskDetail.sourceDeleted) && (
                      <div className={classes.deletedPlaybook}>
                        <div style={{ display: 'flex', marginTop: 2 }}>
                          <Icons.SourceDeleted />
                        </div>
                        <div className={classes.deletedPlaybookWarnText}>
                          {hasBrokenPlaybook
                            ? [
                                purePlaybooks?.find(
                                  p =>
                                    p.functionalAreaId ===
                                    taskDetail.dependencySource
                                )?.project.isDeleted ?? false
                                  ? purePlaybooks?.find(
                                      p =>
                                        p.functionalAreaId ===
                                        taskDetail.dependencySource
                                    )?.project.name
                                  : '',
                                purePlaybooks?.find(
                                  p =>
                                    p.functionalAreaId ===
                                    taskDetail.dependencyTarget
                                )?.project.isDeleted ?? false
                                  ? purePlaybooks?.find(
                                      p =>
                                        p.functionalAreaId ===
                                        taskDetail.dependencyTarget
                                    )?.project.name
                                  : '',
                              ].join(' ') +
                              ' is no longer an active workstream.'
                            : ''}
                          {taskDetail.sourceDeleted
                            ? 'The original dependency has been deleted.'
                            : ''}
                        </div>
                      </div>
                    )}
                  {taskType === 'decision' && (
                    <div>
                      <div
                        className={classes.taskDateInfo}
                        style={{ marginTop: 25 }}
                      >
                        <div className={classes.taskDateInfoItemDecision}>
                          <span className={classes.taskDateInfoItemText}>
                            Who is the decision maker
                          </span>

                          <div
                            className="editTaskName"
                            style={{ width: 'fit-content' }}
                          >
                            <ReactTags
                              classNames={{
                                tagInputField: 'tagInputField',
                                tags: 'tags',
                                remove: 'remove',
                              }}
                              placeholder={
                                'Enter the name of the decision maker'
                              }
                              handleAddition={async (tag: Tagger) => {
                                if (isTaskInViewMode) {
                                  toast('You can only view this task');
                                  return;
                                }
                                setDecisionMaker([...decisionMaker, tag]);
                                const elem = [...decisionMaker, tag];
                                const response =
                                  await componentHelper.updateDecision(
                                    taskDetail.id ?? '',
                                    {
                                      decisionMaker: elem.map(a => a.text),
                                    }
                                  );

                                updateDecisionMaker(
                                  dealTaskList,
                                  taskDetail,
                                  response
                                );
                                // api çağırılacak
                              }}
                              handleDelete={async (i: number) => {
                                if (isTaskInViewMode) {
                                  toast('You can only view this task');
                                  return;
                                }
                                setDecisionMaker(
                                  decisionMaker.filter(
                                    (tag, index) => index !== i
                                  )
                                );
                                const elem = decisionMaker.filter(
                                  (tag, index) => index !== i
                                );
                                const response =
                                  await componentHelper.updateDecision(
                                    taskDetail.id ?? '',
                                    {
                                      decisionMaker: elem.map(a => a.text),
                                    }
                                  );

                                updateDecisionMaker(
                                  dealTaskList,
                                  taskDetail,
                                  response
                                );
                              }}
                              inputFieldPosition="top"
                              tags={decisionMaker}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={classes.taskDateInfo}
                        style={{ marginTop: 25 }}
                      >
                        <span className={classes.taskDateInfoItemText}>
                          What is the decision made
                        </span>
                        <InputBase
                          value={decisionMade}
                          disabled={isTaskInViewMode}
                          onChange={evt => setDecisionMade(evt.target.value)}
                          onBlur={evt =>
                            updateDecision('decisionMade', decisionMade)
                          }
                          placeholder="Please enter the decision that was made"
                          style={{
                            width: '100%',
                            borderRadius: 4,
                            border: '1px solid #b5b3c5',
                            padding: '8px 14px 8px 11px',
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {taskType !== 'decision' && (
                    <div className={classes.taskDetailDependencies}>
                      {dealTaskList
                        .filter(
                          i =>
                            i.parentId === taskDetail.id &&
                            i.type === 'dependency' &&
                            !i.isDeleted &&
                            i.playbookId === (taskDetail.playbookId ?? '')
                        )
                        .map(d => (
                          <DependencyCard
                            key={d.id}
                            dependencies={d}
                            taskDetail={taskDetail}
                            color={
                              functionAreaCollection.find(
                                i => i.id === (d.dependencyTarget ?? '')
                              )?.color
                            }
                          />
                        ))}
                      {taskType !== 'dependency' && (
                        <AddNewDependencyWidget
                          taskId={taskDetail.id ?? ''}
                          sourceFunctionalAreaId={
                            taskDetail.playbookFunction ?? ''
                          }
                          disabled={
                            taskDetail.isArchived || isTaskInViewMode
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                  )}
                  {taskType !== 'decision' && (
                    <>
                      <TaskDetailRidCard
                        allTasks={
                          isUserImo
                            ? allTasks.filter(
                                i =>
                                  i.parentId === taskDetail.id &&
                                  ['risk', 'issue', 'decision'].includes(
                                    i.type ?? ''
                                  ) &&
                                  i.projectRelType === 'owner'
                              )
                            : allTasks.filter(
                                i =>
                                  i.parentId === taskDetail.id &&
                                  (taskDetail.dependencyTarget
                                    ? (playbooks?.filter(
                                        d =>
                                          d.functionalAreaId ===
                                          taskDetail.dependencyTarget
                                      ).length ?? 0) > 0
                                      ? i.projectRelType === 'owner'
                                      : i.projectRelType === 'viewer'
                                    : i) &&
                                  ['risk', 'issue', 'decision'].includes(
                                    i.type ?? ''
                                  )
                              )
                        }
                        setAllTasks={(tasks: ICTask[]) =>
                          setAllTasks(old => [...old, ...tasks])
                        }
                        parentType={taskType}
                        isUserImo={isUserImo}
                        projectRelType={taskDetail.projectRelType ?? ''}
                        setopenParentModal={setopenParentModal}
                        disabled={
                          taskDetail.isArchived || isTaskInViewMode
                            ? true
                            : false
                        }
                        updateTask={updateTask}
                      />
                      <TaskDetailSubTask
                        allTasks={
                          isUserImo
                            ? allTasks.filter(
                                i =>
                                  i.parentId === taskDetail.id &&
                                  ['subtask'].includes(i.type ?? '') &&
                                  i.projectRelType !== 'viewer'
                              )
                            : allTasks.filter(
                                i =>
                                  i.parentId === taskDetail.id &&
                                  ['subtask'].includes(i.type ?? '') &&
                                  (taskDetail.dependencyTarget
                                    ? (playbooks?.filter(
                                        d =>
                                          d.functionalAreaId ===
                                          taskDetail.dependencyTarget
                                      ).length ?? 0) > 0
                                      ? i.projectRelType === 'owner'
                                      : i.projectRelType === 'viewer'
                                    : i)
                              )
                        }
                        setopenParentModal={setopenParentModal}
                        isUserImo={isUserImo}
                        setAllTasks={(tasks: ICTask[]) =>
                          setAllTasks(old => [...old, ...tasks])
                        }
                        setselectedSubTask={setselectedSubTask}
                        selectedSubTask={selectedSubTask}
                        taskDetail={taskDetail}
                        updateSubTask={updateSubTask}
                        disabled={
                          taskDetail.isArchived || isTaskInViewMode
                            ? true
                            : false
                        }
                        updateTask={updateTask}
                      />
                    </>
                  )}
                </div>
                <div className={classes.taskDetailModalBodyRight}>
                  <Accordion
                    className="customAccordion"
                    defaultExpanded={taskDetailExpand}
                    onChange={toggleTaskDetailAccordion}
                  >
                    <AccordionSummary
                      expandIcon={<Icons.DownArrow />}
                      aria-controls="paneltaskDetail-content"
                      id="paneltaskDetail-header"
                    >
                      {taskType !== 'task' && taskType !== 'milestone' && (
                        <div className={classes.customCardHeaderLeftIcon}>
                          {getModalIcon(taskType as DependencyType)}
                        </div>
                      )}
                      <span
                        className="customAccordionTitle"
                        style={{ marginTop: '0.7em' }}
                      >
                        {taskType.charAt(0).toUpperCase() + taskType.slice(1)}{' '}
                        Details
                      </span>
                      {!taskDetailExpand && (
                        <span
                          className="customAccordionSpan"
                          style={{ marginTop: '1.1em', marginLeft: '0.9em' }}
                        >
                          Due date, assignee, description, due diligence & other
                          details
                        </span>
                      )}
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className={classes.taskDateInfo}>
                        <div className={classes.taskDateInfoItemDate}>
                          <span className={classes.taskDateInfoItemText}>
                            Date
                          </span>
                          <CustomDateRange
                            startDate={taskStartDate}
                            endDate={taskDueDate}
                            disabled={
                              (taskDetail.projectRelType === 'source' &&
                                !isUserImo) ||
                              taskDetail.isArchived ||
                              isTaskInViewMode
                                ? true
                                : false
                            }
                            onDateChange={(
                              startDate: Date | null,
                              endDate: Date | null
                            ) => {
                              if (dealSpaceEnd) {
                                dispatch(postShowTrialEndModal(true));
                                return;
                              }
                              updateTaskDetailService(
                                'startDate',
                                startDate
                                  ? moment(startDate).format('YYYY-MM-DD')
                                  : null
                              );
                              updateTaskDetailService(
                                'dueDate',
                                endDate
                                  ? moment(endDate).format('YYYY-MM-DD')
                                  : null
                              );
                            }}
                          />
                        </div>
                        <div className={classes.taskDateInfoItem}>
                          <span className={classes.taskDateInfoItemText}>
                            Assign
                          </span>
                          <UserMenu
                            username={username}
                            setUsername={setUsername}
                            handleSelect={(selectedUsername: string | null) => {
                              if (dealSpaceEnd) {
                                dispatch(postShowTrialEndModal(true));
                                return;
                              }
                              updateTaskDetailService(
                                'assignee',
                                selectedUsername
                              );
                            }}
                            disabled={
                              (projectRelType === 'source' && !isUserImo) ||
                              isTaskInViewMode ||
                              taskDetail.isArchived
                                ? true
                                : false
                            }
                            playbookId={taskDetail.playbookId ?? ''}
                          />
                        </div>
                      </div>
                      {['milestone', 'task'].includes(taskType) && (
                        <div className={classes.taskMilestone}>
                          <Checkbox
                            color="default"
                            checked={taskType === 'milestone'}
                            onChange={handleCheckboxChange}
                            style={{ marginLeft: 10, color: '#4C43AA' }}
                            icon={
                              taskType === 'milestone' ? (
                                <Icons.Diamond color="#4C43AA" />
                              ) : (
                                <Icons.Diamond color="#4C43AA" />
                              )
                            }
                            checkedIcon={
                              taskType === 'milestone' ? (
                                <Icons.DiamondFilled
                                  className="diamondColor"
                                  color="#4C43AA"
                                />
                              ) : (
                                <Icons.DiamondFilled />
                              )
                            }
                            disabled={taskDetail.isArchived ? true : false}
                          />
                          <div
                            style={{
                              display: 'flex',
                              color: '#4C43AA',
                              fontFamily: 'Inter',
                              fontSize: 15,
                              fontWeight: 600,
                              alignItems: 'center',
                            }}
                          >
                            {isMilestone
                              ? 'This item as a milestone'
                              : 'Mark this item as a milestone'}
                          </div>
                        </div>
                      )}

                      {taskType === 'risk' && (
                        <div
                          className={classes.taskDateInfo}
                          style={{ marginTop: 25 }}
                        >
                          <div className={classes.taskDateInfoItemRid}>
                            <span className={classes.taskDateInfoItemText}>
                              Risk Impact
                            </span>
                            <FormControl fullWidth>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={riskImpact}
                                disabled={isTaskInViewMode}
                                onChange={evt => {
                                  setRiskImpact(evt.target.value as string);
                                  updateRisk('impact', evt.target.value);
                                  //updateTaskDetailService(
                                  //  'focusArea',
                                  //  evt.target.value as string
                                  //);
                                }}
                                className="customOutlinedInput"
                                IconComponent={() => null}
                              >
                                <MenuItem value={'high'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.RiskImpact color={'#FF5630'} />
                                    <div style={{ marginLeft: '0.5em' }}>
                                      High
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'medium'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.RiskImpact color={'#FFAB00'} />
                                    <div style={{ marginLeft: '0.5em' }}>
                                      Medium
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'low'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.RiskImpact color={'#36B37E'} />
                                    <div style={{ marginLeft: '0.5em' }}>
                                      Low
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'none'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.RiskImpact color={'#A7A5BA'} />{' '}
                                    <div style={{ marginLeft: '0.5em' }}>
                                      None
                                    </div>
                                  </Box>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          <div className={classes.taskDateInfoItemRid}>
                            <span className={classes.taskDateInfoItemText}>
                              Risk Likelihood
                            </span>
                            <FormControl fullWidth>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={riskLikeliHood}
                                onChange={evt => {
                                  setRiskLikelihood(evt.target.value as string);
                                  updateRisk('likelihood', evt.target.value);
                                }}
                                className="customOutlinedInput"
                                disabled={isTaskInViewMode}
                                IconComponent={() => null}
                              >
                                <MenuItem value={'high'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.Box color={'#FF5630'} />
                                    <div style={{ marginLeft: '0.2em' }}>
                                      High
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'medium'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.Box color={'#FFAB00'} />
                                    <div style={{ marginLeft: '0.2em' }}>
                                      Medium
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'low'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.Box color={'#36B37E'} />
                                    <div style={{ marginLeft: '0.2em' }}>
                                      Low
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'none'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.Box color={'#A7A5BA'} />{' '}
                                    <div style={{ marginLeft: '0.2em' }}>
                                      None
                                    </div>
                                  </Box>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                      )}

                      {taskType === 'issue' && (
                        <div
                          className={classes.taskDateInfo}
                          style={{ marginTop: 25 }}
                        >
                          <div className={classes.taskDateInfoItemRid}>
                            <span className={classes.taskDateInfoItemText}>
                              Issue Impact
                            </span>
                            <FormControl fullWidth>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={issueImpact}
                                onChange={evt => {
                                  setIssueImpact(evt.target.value as string);
                                  updateIssue('impact', evt.target.value);
                                  //updateTaskDetailService(
                                  //  'focusArea',
                                  //  evt.target.value as string
                                  //);
                                }}
                                className="customOutlinedInput"
                                disabled={isTaskInViewMode}
                                IconComponent={() => null}
                              >
                                <MenuItem value={'high'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.RiskImpact color={'#FF5630'} />
                                    <div style={{ marginLeft: '0.5em' }}>
                                      High Impact
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'medium'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.RiskImpact color={'#FFAB00'} />
                                    <div style={{ marginLeft: '0.5em' }}>
                                      Medium Impact
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'low'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.RiskImpact color={'#36B37E'} />
                                    <div style={{ marginLeft: '0.5em' }}>
                                      Low Impact
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'none'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.RiskImpact color={'#A7A5BA'} />{' '}
                                    <div style={{ marginLeft: '0.5em' }}>
                                      None
                                    </div>
                                  </Box>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          <div className={classes.taskDateInfoItemRid}>
                            <span className={classes.taskDateInfoItemText}>
                              Issues Priority
                            </span>
                            <FormControl>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={issuePriority}
                                onChange={evt => {
                                  setIssuePriority(evt.target.value as string);
                                  updateTaskDetailService(
                                    'priority',
                                    evt.target.value
                                  ); //issue Priority Proporty Needed
                                  //updateTaskDetailService(
                                  //  'focusArea',
                                  //  evt.target.value as string
                                  //);
                                }}
                                className="customOutlinedInput"
                                disabled={isTaskInViewMode}
                                IconComponent={() => null}
                              >
                                <MenuItem value={'high'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.FlagFilled color={'#FF5630'} />
                                    <div style={{ marginLeft: '0.5em' }}>
                                      High Priority
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'medium'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.FlagFilled color={'#FFAB00'} />
                                    <div style={{ marginLeft: '0.5em' }}>
                                      Medium Priority
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'low'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.FlagFilled color={'#36B37E'} />
                                    <div style={{ marginLeft: '0.5em' }}>
                                      Low Priority
                                    </div>
                                  </Box>
                                </MenuItem>
                                <MenuItem value={'none'}>
                                  <Box className={classes.menuItems}>
                                    <Icons.FlagFilled color={'#A7A5BA'} />{' '}
                                    <div style={{ marginLeft: '0.5em' }}>
                                      None
                                    </div>
                                  </Box>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                      )}

                      {taskType === 'decision' && (
                        <div>
                          <div
                            className={classes.taskDateInfo}
                            style={{ marginTop: 25 }}
                          >
                            <div className={classes.taskDateInfoItemDecision}>
                              <span className={classes.taskDateInfoItemText}>
                                Decision Priority
                              </span>
                              <FormControl fullWidth>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={decisionPriority}
                                  onChange={evt => {
                                    setDecisionPriority(
                                      evt.target.value as string
                                    );
                                    updateTaskDetailService(
                                      'priority',
                                      evt.target.value
                                    );
                                  }}
                                  className="customOutlinedInput"
                                  disabled={isTaskInViewMode}
                                  IconComponent={ArrowDropDownIcon}
                                >
                                  <MenuItem value={'high'}>
                                    <Box className={classes.menuItems}>
                                      <Icons.FlagFilled color={'#FF5630'} />
                                      <div style={{ marginLeft: '0.5em' }}>
                                        High Priority
                                      </div>
                                    </Box>
                                  </MenuItem>
                                  <MenuItem value={'medium'}>
                                    <Box className={classes.menuItems}>
                                      <Icons.FlagFilled color={'#FFAB00'} />
                                      <div style={{ marginLeft: '0.5em' }}>
                                        Medium Priority
                                      </div>
                                    </Box>
                                  </MenuItem>
                                  <MenuItem value={'low'}>
                                    <Box className={classes.menuItems}>
                                      <Icons.FlagFilled color={'#36B37E'} />
                                      <div style={{ marginLeft: '0.5em' }}>
                                        Low Priority
                                      </div>
                                    </Box>
                                  </MenuItem>
                                  <MenuItem value={'none'}>
                                    <Box className={classes.menuItems}>
                                      <Icons.FlagFilled color={'#A7A5BA'} />{' '}
                                      <div style={{ marginLeft: '0.5em' }}>
                                        None
                                      </div>
                                    </Box>
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      )}

                      {taskType === 'dependency' && (
                        <div
                          className={classes.taskDateInfo}
                          style={{ marginTop: 25 }}
                        >
                          <div className={classes.taskDateInfoItemRid}></div>
                        </div>
                      )}

                      <div className={classes.taskDesc}>
                        <span className={classes.taskDateInfoItemText}>
                          {taskType !== 'task' &&
                            taskType.charAt(0).toUpperCase() +
                              taskType.slice(1)}{' '}
                          Description
                        </span>
                        {isDescriptionEdit ? (
                          <CustomCkEditor
                            //value={taskDetail.description}
                            value={description}
                            // onMouseLeave={() => {
                            //   setIsDescriptionEdit(false);
                            //   updateTaskDetailService('description', description);
                            // }}
                            onChange={(value: string) => {
                              setDescription(value);
                              updateTaskDetailService('description', value);
                            }}
                            onBlur={() => {
                              console.log('description', description);
                            }}
                            setEditing={setIsDescriptionEdit}
                            mentions={userList.filter(
                              item => item.playbookId === pid
                            )}
                            height={225}
                          />
                        ) : (
                          <div
                            className={classes.taskDateInfoItemTextarea}
                            onClick={() => {
                              if (taskDetail.isArchived) {
                                return;
                              }
                              if (dealSpaceEnd) {
                                dispatch(postShowTrialEndModal(true));
                                return;
                              }
                              setIsDescriptionEdit(true);
                            }}
                          >
                            {description !== '' ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: description,
                                }}
                                className="dx-htmleditor-content"
                              />
                            ) : (
                              <Input
                                disableUnderline
                                fullWidth
                                className={classes.customInput}
                                placeholder={getDescription(
                                  taskType as DependencyType
                                )}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    className="customAccordion"
                    defaultExpanded={filesExpand}
                    onChange={toggleFilesAccordion}
                  >
                    <AccordionSummary
                      expandIcon={<Icons.DownArrow />}
                      aria-controls="panelFiles-content"
                      id="panelFiles-header"
                    >
                      <span className="customAccordionTitle">Files</span>
                      {!filesExpand && (
                        <span
                          className="customAccordionSpan"
                          style={{ marginTop: '0.2em', marginLeft: '0.9em' }}
                        >
                          Files attached, Total file count ={' '}
                          {attachments.length}
                        </span>
                      )}
                    </AccordionSummary>
                    <AccordionDetails>
                      <CustomDropZone
                        taskAttachments={attachments}
                        setattachments={setattachments}
                        deleteAttachments={deleteAttachments}
                        taskId={taskDetail.id ?? ''}
                        disabled={
                          taskDetail.isArchived || dealSpaceEnd ? true : false
                        }
                      />
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    className="customAccordion noborder"
                    defaultExpanded={commentsExpand}
                    onChange={toggleCommentsAccordion}
                  >
                    <AccordionSummary
                      expandIcon={<Icons.DownArrow />}
                      aria-controls="panelComments-content"
                      id="panelComments-header"
                    >
                      <span className="customAccordionTitle">Comments</span>
                      {!commentsExpand && (
                        <span
                          className="customAccordionSpan"
                          style={{ marginTop: '0.2em', marginLeft: '0.9em' }}
                        >
                          Total comments = {commentList.length}
                        </span>
                      )}
                    </AccordionSummary>
                    <AccordionDetails>
                      <div>
                        <div className="taskDetailCommentArea">
                          <Avatar
                            sx={{
                              bgcolor: mergefloColors.getUserColors(
                                currentUser?.charAt(0) ?? ''
                              ),
                              width: 34,
                              height: 34,
                              fontSize: 15,
                            }}
                          >
                            {userInfo
                              ? userInfo.name[0].toUpperCase() +
                                userInfo.surname[0].toUpperCase()
                              : 'M'}
                          </Avatar>
                          {isCommentEditor ? (
                            <div
                              style={{
                                marginLeft: 20,
                                width: 450,
                              }}
                            >
                              <CustomCkEditor
                                //onBlur={() => setIsCommentEditor(false)}
                                value={taskComment}
                                onChange={(value: string) => {
                                  setTaskComment(value);
                                  saveComments(value);
                                }}
                                setEditing={setIsCommentEditor}
                                mentions={userList.filter(
                                  item => item.playbookId === pid
                                )}
                                height={150}
                              />
                            </div>
                          ) : (
                            <div
                              className="taskDetailDescriptionInput"
                              onClick={() => {
                                if (taskDetail.isArchived) {
                                  return;
                                }
                                if (dealSpaceEnd) {
                                  dispatch(postShowTrialEndModal(true));
                                  return;
                                }
                                setIsCommentEditor(true);
                              }}
                              dangerouslySetInnerHTML={{
                                __html:
                                  taskComment !== ''
                                    ? taskComment
                                    : 'Post your comments',
                              }}
                            ></div>
                          )}

                          {/* <InputBase
                            value={''}
                            placeholder={'Post your comments'}
                            onChange={evt => {}}
                            style={{ width: '100%' }}
                            multiline={true}
                          /> */}
                        </div>
                        <div className="taskDetailPostButton">
                          {/*     <Button
                            className="FuchsiaBlueButton"
                            style={{ width: 126, margin: '14px 0px' }}
                            onClick={() => {
                              setIsCommentEditor(false);
                              saveComments(taskComment);
                            }}
                            disabled={taskDetail.isArchived ? true : false}
                          >
                            <span>Post Comment</span>
                          </Button> */}
                          {/* {isCommentEditor && (
                        <Button
                          style={{
                            marginLeft: 10,
                            textTransform: 'none',
                          }}
                          variant="text"
                          onClick={() => setIsCommentEditor(false)}
                        >
                          Cancel
                        </Button>
                      )} */}
                        </div>
                        <div
                          className="taskDetailCommentList"
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          {commentList.map(i => {
                            return (
                              <div
                                style={{ display: 'flex', padding: '5px 0' }}
                                key={i.id}
                              >
                                <div className="commentAvatar">
                                  <Avatar
                                    sx={{
                                      bgcolor: mergefloColors.getUserColors(
                                        i.username.charAt(0) ?? ''
                                      ),
                                      width: 34,
                                      height: 34,
                                      fontSize: 15,
                                    }}
                                  >
                                    {userList
                                      .find(
                                        user => user.username === i.username
                                      )
                                      ?.name?.charAt(0)
                                      ?.toUpperCase()}
                                    {userList
                                      .find(
                                        user => user.username === i.username
                                      )
                                      ?.surname?.charAt(0)
                                      ?.toUpperCase()}
                                  </Avatar>
                                </div>
                                <div className="comment">
                                  <div className="commentUser">
                                    {`${
                                      userList.find(
                                        user => user.username === i.username
                                      )?.name
                                    } ${
                                      userList.find(
                                        user => user.username === i.username
                                      )?.surname
                                    }`}{' '}
                                    -{' '}
                                    <small>
                                      {moment().format('MM/DD/YYYY') !==
                                      moment(i.createdAt).format('MM/DD/YYYY')
                                        ? moment(i.createdAt).format(
                                            'MM/DD/YYYY HH:mm'
                                          )
                                        : moment(i.createdAt).fromNow()}
                                    </small>
                                  </div>
                                  <div className="commentText">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: i.comment,
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
              <ParentTaskDialog
                handleClose={setopenParentModal}
                open={openParentModal}
                taskId={selectedSubTask?.id ?? ''}
                updateTaskProperty={updateTaskDetailService}
              />
            </>
          )}
        </div>

        {taskDetailHistory?.length > 0 && (
          <button
            className={classes.modalButtonRight}
            onClick={() => TaskDetailHistoryChange(false)}
            disabled={disableTaskDetailHistoryChangeButton(false)}
          >
            <ArrowForwardIosIcon
              sx={{
                fontSize: 35,
                color: '#fff',
              }}
            />
          </button>
        )}
      </div>
    </Modal>
  );
};

export default TaskDetailModal;
